import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { RelatorioDreParams } from '../../models/relatorios/relatorio-dre.model';

@Injectable({
  providedIn: 'root',
})
export class RelatorioDreService implements ApiInterface {
  constructor(private apiService: ApiService) { }

  get<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<any>(patch);
  }

  getText<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.readText<any>(patch);
  }

  getById<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }
  post<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  put<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  delete<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // Método para emitir o relatório DRE
  emitirRelatorio(params: RelatorioDreParams): Observable<string> {
    return this.getText<string>(
      '/relatorios/relatorio-DRE',
      params
    );
  }
}
